import React from 'react'
import Link from 'gatsby-link'

const SmartLink = ({ children, className, to, href, ...other }) => {
  return href ? (
    <a className={className} href={href} {...other}>{children}</a>
  ) : (
    <Link className={className} to={to} {...other}>{children}</Link>
  )
}

export default SmartLink



// WEBPACK FOOTER //
// ./src/components/SmartLink/index.js